import React from 'react'
import { localisationMaster } from 'Localisation/Localisation'
import { Link } from 'react-router-dom'
import { ReactComponent as ArrowRight } from 'components/UI/icons/arrow-down-s-line.svg'
import './Bundles.scss'

const Bundles = ({ program, age, questions_count, name, id, icon, added }) => (
  <div className='placementTestBundle'>
    <div className='placementTestBundle__left'>
      <div className='placementTestBundle__options'>
        <p>
          {age.name} | {program?.name}
        </p>
        <p>{name}</p>
        <p>
          {localisationMaster(
            'text_42',
            'c/tests/placement-test/create-widget',
          )}
          : {questions_count || 0}
        </p>
      </div>
    </div>
    <div className='placementTestBundle__right'>
      <div
        className={
          !added ? 'placementTestBundle__plus' : 'placementTestBundle__toggle'
        }
      >
        {icon()}
      </div>
      <div className='placementTestBundle__text'>
        <Link to={`/widget/bundle/${id}`} target='_blank'>
          <span>
            {localisationMaster('link', 'c/tests/placement-test/create-widget')}
          </span>
          <ArrowRight />
        </Link>
      </div>
    </div>
  </div>
)

export default Bundles
